import React from 'react'

import { CaretIcon } from './icons'
import { RoomRow } from './RoomRow'
import { Caret, GroupBody, GroupHeaderButton, GroupSection, GroupTitle } from './styles'

import type { RoomAvailability, RoomGroup } from '../../models/rooms'

type RoomGroupSectionProps = {
    group: RoomGroup
    roomAvailabilityById: Record<string, RoomAvailability>
    attachedRoomId: string | null
    attachedRoomLabel?: string
    attachingRoomId: string | null
    onToggleGroup: (groupId: string) => void
    onAttachRoom: (roomId: string) => void
}

export function RoomGroupSectionItem({
    group,
    roomAvailabilityById,
    attachedRoomId,
    attachedRoomLabel,
    attachingRoomId,
    onToggleGroup,
    onAttachRoom,
}: RoomGroupSectionProps) {
    return (
        <GroupSection>
            <GroupHeaderButton type="button" aria-expanded={!group.collapsed} onClick={() => onToggleGroup(group.id)}>
                <GroupTitle>{group.title}</GroupTitle>
                <Caret $expanded={!group.collapsed}>
                    <CaretIcon />
                </Caret>
            </GroupHeaderButton>

            {!group.collapsed ? (
                <GroupBody>
                    {group.rooms.map((room) => (
                        <RoomRow
                            key={room.id}
                            room={room}
                            availability={roomAvailabilityById[room.id] ?? null}
                            isAttached={attachedRoomId === room.id}
                            attachedLabel={attachedRoomLabel}
                            isAttaching={attachingRoomId === room.id}
                            onAttach={onAttachRoom}
                        />
                    ))}
                </GroupBody>
            ) : null}
        </GroupSection>
    )
}
